import React from 'react';

const Card = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`auth-card rounded-2xl shadow-2xl p-8 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;